<div id="wrapper" class="h-100vh p-3">
  <div id="content-wrapper" class="d-flex flex-column ml-0">
    <div>
      <h1 class="logo text-center mb-4">
        <img src="/assets/doctors-next/login-logo.png" alt="Logo" />
      </h1>
      <div
        class="text-center mb-4"
        style="font-weight: bold; font-size: 25px !important"
      >
        <p>ロックを解除しました</p>
      </div>
      <div class="txt text-center mb-4">
        <p>
          あなたのアカウントのロックが解除されました。{{
            countdown
          }}秒後に、Doctors Nextのトップページへ自動的に移動します。
        </p>
      </div>

      <div class="text-center mb-4 text-gray-700">
        <p>
          自動的に移動しない場合は、「トップに戻る」ボタンを押してください。
        </p>
      </div>
      <div class="bnt02 mb-3 text-center">
        <a
          (click)="redirect()"
          style="width: 350px; max-width: unset; font-size: 20px; cursor: pointer;"
          class="login-btn"
          >トップに戻る</a
        >
      </div>
    </div>
  </div>
</div>
